import { ValidationRule } from 'react-hook-form';
import { IUserCredentials } from '../types/IUserCredentials';
import { required } from '@bpba/form-components';

const otpValidation = {
  message: 'Este campo debe contener 6 números',
  value: /^[0-9]{6}$/,
};

export const SignUpOtpRules: Record<string, Record<keyof IUserCredentials, Record<string, ValidationRule>>> = {
  rules: {
    email: { required },
    otp: { required, pattern: otpValidation },
  },
};
